export default "__VITE_ASSET__DoxyIMeV__"